module.exports = __webpack_public_path__ + "img/compare_in_countries.73e4c049.jpg";